import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button } from "reactstrap";
import { t } from "i18next";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import { getFeedbacks, deleteFeedback } from "../../../api/feedback";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

export default function DealFeedback({ dealId }) {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || {};
  const hasPermission = (action) => {
    if (role.name === "super admin") return true;
    return (
      role.permissions &&
      role.permissions.some(
        (perm) => perm.resource === "Sales" && perm.actions.includes(action)
      )
    );
  };

  const canEdit = () => hasPermission("update");
  const canDelete = () => hasPermission("delete");
  const canRead = () => hasPermission("update") || hasPermission("delete");

  const {
    response,
    loading,
    error,
    setPage,
    page,
    totalPages,
  } = usePagination(getFeedbacks, { dealId }, Boolean(dealId));

  const handleDelete = async (id) => {
    if (window.confirm(t("Are you sure you want to delete this feedback?"))) {
      try {
        await deleteFeedback(id);
        setPage(1);
      } catch (err) {
        console.error("Delete failed:", err);
        alert(t("Failed to delete feedback."));
      }
    }
  };

  if (!canRead()) {
    return <div>{t("You do not have permission to view feedback.")}</div>;
  }

  return (
    <div className="mt-4">
      {response && response.length > 0 && !loading ? (
        <>
          {/* <Breadcrumbs
            title={`${t("Feedback")} ${t("Table")}`}
            addUrl={dealId ? `/feedback/add/${dealId}` : null}
            hasAddBtn={canCreate()}
          /> */}
          <CustomTable
            emptyMsg={t("No feedback found.")}
            data={response}
            loading={loading}
            error={error}
            cols={[
              {
                label: t("Client Satisfaction"),
                key: "clientSatisfaction",
                style: { width: "15%" },
              },
              {
                label: t("Campaign Delivered"),
                key: "campaignDelivered",
                style: { width: "20%" },
                renderer: (row) => (row.campaignDelivered ? t("Yes") : t("No")),
              },
              {
                label: t("Upsell Potential"),
                key: "upsellPotential",
                style: { width: "15%" },
                renderer: (row) => (row.upsellPotential ? t("Yes") : t("No")),
              },
              {
                label: t("Notes"),
                key: "notes",
                style: { width: "35%" },
              },
              {
                label: t("Actions"),
                key: "actions",
                style: { width: "15%" },
                renderer: (row) => (
                  <div className="d-flex gap-2">
                    {canEdit() && (
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => navigate(`/feedback/edit/${row._id}`)}
                      >
                        {t("Edit")}
                      </Button>
                    )}
                    {canDelete() && (
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(row._id)}
                      >
                        {t("Delete")}
                      </Button>
                    )}
                  </div>
                ),
              },
            ]}
          />
          <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
        </>
      ) : (
        !loading && <div>{t("No results found.")}</div>
      )}
    </div>
  );
}
